const DB_NAME = 'taskpriority-sync'
const STORE_NAME = 'outbox'

export interface QueuedMutation {
  mutationId: string
  entity: 'snapshot'
  action: 'replace'
  payload: unknown
  createdAt: number
}

function database(): Promise<IDBDatabase> {
  return new Promise((resolve, reject) => {
    const request = indexedDB.open(DB_NAME, 1)
    request.onupgradeneeded = () => request.result.createObjectStore(STORE_NAME, { keyPath: 'mutationId' })
    request.onsuccess = () => resolve(request.result)
    request.onerror = () => reject(request.error)
  })
}

async function transaction<T>(mode: IDBTransactionMode, action: (store: IDBObjectStore) => IDBRequest<T>) {
  const db = await database()
  return new Promise<T>((resolve, reject) => {
    const tx = db.transaction(STORE_NAME, mode)
    const request = action(tx.objectStore(STORE_NAME))
    request.onsuccess = () => resolve(request.result)
    request.onerror = () => reject(request.error)
    tx.oncomplete = () => db.close()
  })
}

export const outbox = {
  async putLatest(payload: unknown) {
    const mutation: QueuedMutation = { mutationId: crypto.randomUUID(), entity: 'snapshot', action: 'replace', payload, createdAt: Date.now() }
    const existing = await this.all()
    await Promise.all(existing.map((item) => transaction('readwrite', (store) => store.delete(item.mutationId))))
    await transaction('readwrite', (store) => store.put(mutation))
    return mutation
  },
  all: () => transaction<QueuedMutation[]>('readonly', (store) => store.getAll()),
  remove: (id: string) => transaction('readwrite', (store) => store.delete(id)),
  clear: () => transaction('readwrite', (store) => store.clear()),
}
